module.exports = __webpack_public_path__ + "static/media/Maf_Curso_04ParticipacionOral.0485632b.jpg";